export enum ImageCoverageTableColumnIds {
  CATEGORY_NAME = 'CATEGORY_NAME',
  VENUE_SLUG = 'VENUE_SLUG',
  COVERAGE = 'COVERAGE',
}
